import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    OnDestroy,
    Output,
    ViewChild,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { VisibilityService } from './services';

@Component({
    selector: 'app-end-of-scroll',
    template: '<div style="height: 2px" #endOfScroll> </div>',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EndOfScrollComponent implements OnDestroy, AfterViewInit {
    @ViewChild('endOfScroll', { static: false }) public endOfScrollView: ElementRef;
    @Output() public endOfScroll: EventEmitter<boolean> = new EventEmitter<boolean>();
    private visibilitySubscription: Subscription = null;

    public constructor(private visibilityService: VisibilityService, private cdf: ChangeDetectorRef) {}
    public ngAfterViewInit(): void {
        this.visibilitySubscription = this.visibilityService
            .elementInSight(this.endOfScrollView)
            .subscribe((isVisible) => {
                this.endOfScroll.emit(isVisible), this.cdf.detectChanges();
            });
    }
    public ngOnDestroy(): void {
        if (!this.visibilitySubscription || this.visibilitySubscription.closed) {
            return;
        }

        this.visibilitySubscription.unsubscribe();
    }
}
